export const saveRequests = {}

const consumedDrafts = {}

export const isDraftConsumed = draftId => Boolean(consumedDrafts[draftId])

export const trackSaveRequest = (draftId, request) => {
  const requests = saveRequests[draftId] || new Set()
  requests.add(request)
  saveRequests[draftId] = requests

  const settle = () => {
    requests.delete(request)
    if (!requests.size) delete saveRequests[draftId]
  }

  request.then(settle, settle)

  return request
}

export const drainSaveRequests = draftId => {
  const requests = saveRequests[draftId]
  if (!requests?.size) return Promise.resolve()
  return Promise.all(Array.from(requests)).then(() =>
    drainSaveRequests(draftId)
  )
}

export const beginDraftConsumption = (draftId, consumerType) => {
  const consumers = consumedDrafts[draftId] || {}
  consumers[consumerType] = (consumers[consumerType] || 0) + 1
  consumedDrafts[draftId] = consumers
  return drainSaveRequests(draftId)
}

export const releaseDraftConsumption = (draftId, consumerType) => {
  const consumers = consumedDrafts[draftId]
  if (!consumers?.[consumerType]) return
  consumers[consumerType] -= 1
  if (!consumers[consumerType]) delete consumers[consumerType]
  if (!Object.keys(consumers).length) delete consumedDrafts[draftId]
}
